import React, { Component } from "react";
import {
	Tooltip,
	ResponsiveContainer,
	RadarChart,
	Radar,
	PolarGrid,
	PolarAngleAxis
} from "recharts";
import { calculaPorcentaje } from "../utils/helpers";

export default class GraficoRadarChirigotas extends Component {
	constructor(props) {
		super();
		this.state = {
			fase: props.tiempo.cod,
			data: ""
		};
		// BINDINGS
		this.componentWillMount = this.componentWillMount.bind(this);
		this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
	}

	componentWillMount(props) {
		if (this.props.ide && this.props.tiempo.cod) {
			let main = this.props.agrupaciones[this.props.ide];
			let sec = this.props.agrupaciones[this.props.ide];

			let tipA = main[`${this.state.fase}tip`];
			let pasA = main[`${this.state.fase}pas`];
			let estA = main[`${this.state.fase}est`];
			let cupA = main[`${this.state.fase}cup`];
			let popA = main[`${this.state.fase}pop`];
			let preA = main[`${this.state.fase}pre`];

			this.setState({
				data: [
					{
						subject: "Tipo",
						A: calculaPorcentaje(tipA, 18)
					},
					{
						subject: "Pasodoble",
						A: calculaPorcentaje(pasA, 72)
					},
					{
						subject: "Estribillo",
						A: calculaPorcentaje(estA, 24)
					},
					{
						subject: "Cuplés",
						A: calculaPorcentaje(cupA, 108)
					},
					{
						subject: "Popurrí",
						A: calculaPorcentaje(popA, 60)
					},
					{
						subject: "Presentación",
						A: calculaPorcentaje(preA, 18)
					}
				]
			});
		}
	}

	componentWillReceiveProps(props) {
		if (props.ideSec) {
			let main = props.agrupaciones[props.ide];
			let sec = props.agrupaciones[props.ideSec];

			let tipA = main[`${this.state.fase}tip`];
			let pasA = main[`${this.state.fase}pas`];
			let estA = main[`${this.state.fase}est`];
			let cupA = main[`${this.state.fase}cup`];
			let popA = main[`${this.state.fase}pop`];
			let preA = main[`${this.state.fase}pre`];

			let tipB = sec[`${this.state.fase}tip`];
			let pasB = sec[`${this.state.fase}pas`];
			let estB = sec[`${this.state.fase}est`];
			let cupB = sec[`${this.state.fase}cup`];
			let popB = sec[`${this.state.fase}pop`];
			let preB = sec[`${this.state.fase}pre`];

			this.setState({
				data: [
					{
						subject: "Tipo",
						A: calculaPorcentaje(tipA, 18),
						B: calculaPorcentaje(tipB, 18)
					},
					{
						subject: "Pasodoble",
						A: calculaPorcentaje(pasA, 72),
						B: calculaPorcentaje(pasB, 72)
					},
					{
						subject: "Estribillo",
						A: calculaPorcentaje(estA, 24),
						B: calculaPorcentaje(estB, 24)
					},
					{
						subject: "Cuplés",
						A: calculaPorcentaje(cupA, 108),
						B: calculaPorcentaje(cupB, 108)
					},
					{
						subject: "Popurrí",
						A: calculaPorcentaje(popA, 60),
						B: calculaPorcentaje(popB, 60)
					},
					{
						subject: "Presentación",
						A: calculaPorcentaje(preA, 18),
						B: calculaPorcentaje(preB, 18)
					}
				]
			});
		}
	}
	render() {
		const bunker = "#0F1419";

		return (
			<div className="radar-chart">
				<br />
				<div
					id="contenedor-radar"
					style={{
						width: "100%",
						fontFamily: "Roboto",
						fontWeight: "300",
						fontSize: "14px",
						margin: "0 auto",
						height: "310px"
					}}
				>
					<ResponsiveContainer width="100%">
						<RadarChart outerRadius="90%" data={this.state.data}>
							<PolarGrid
								gridType="circle"
								style={{
									stroke: "#D0D0D0",
									strokeWidth: "1px",
									opacity: "0.6",
									mixBlendMode: "multiply"
								}}
							/>
							<Tooltip
								labelStyle={{ fontWeight: 300, paddingBottom: 1 }}
								itemStyle={{
									paddingTop: 1,
									fontWeight: 700,
									fontSize: 16,
									paddingBottom: 1
								}}
								formatter={x => `${x} %`}
								separator=" "
							/>
							<Radar
								name=" "
								dataKey="A"
								fill={this.props.mainColor}
								stroke={this.props.mainColor}
								strokeWidth="2px"
								fillOpacity={1}
								style={{
									mixBlendMode: "multiply"
								}}
							/>
							<Radar
								name=" "
								dataKey="B"
								stroke={bunker}
								fill="#EEEEEE"
								strokeWidth="2px"
								fillOpacity={1}
								style={{
									mixBlendMode: "multiply"
								}}
							/>
							<PolarAngleAxis dataKey="subject" />
						</RadarChart>
					</ResponsiveContainer>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/GraficoRadarChirigotas.js